import React from 'react';

import { useTranslation } from 'hooks';
import { Preferences } from 'Profile/components';

export default function UpcomingTripPreferences({
	allowCancellation,
	defaultValues,
	showPreferences = false,
}) {
	const { t } = useTranslation();

	return (
		<div className="fs-trip__preferences">
			<h3>{t('Perfection in every detail')}</h3>
			<p className="fs-trip__preferences__description">
				{t('Knowing a little more will allow us to add just the right touches to your stay.')}
			</p>

			{defaultValues.tripPurpose && (
				<ul className="fs-your-preferences__preference__selected-preferences">
					<li>{defaultValues.tripPurpose}</li>
				</ul>
			)}

			{showPreferences && <Preferences canEdit={allowCancellation} />}

			{!allowCancellation && (
				<div className="fs-trip__no-changes">
					{t(
						'Trip details cannot be modified online within 48 hours of check-in date. Please call 1-800-819-5053 for assistance.'
					)}
				</div>
			)}
		</div>
	);
}
